// src/index.ts

// 🔒 Ofuscación de localStorage — debe ser lo primero
import { installSecureStorage } from './utils/secure-storage';
installSecureStorage();

// 🔤 Fuentes (solo variable: sans + mono)
import '@fontsource-variable/geist';       // Geist Variable Sans
import '@fontsource-variable/geist-mono';  // Geist Mono Variable

// NPM Global Styles
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';

// ✅ Importá el CSS global para que se apliquen los --font-sans / --font-mono
import './global.css';

// NPM Global Scripts
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import Swal from 'sweetalert2';
import $ from 'jquery';

// Asignar variables al entorno global para compatibilidad con código existente
window.$ = window.jQuery = $;
window.Swal = Swal;

// turn.js detectará jQuery automáticamente si se carga después
import 'turn.js';

// UI base
import './components/loading-screen.js';
import './clients/components/header-client.js';

// Router
import { mainRouter } from './utils/router';

// Auth
import { setupAuthOnAppStart } from './services/auth-service';

/* =========================================================================
   Boot ordenado: primero auth, luego router
   ========================================================================= */
const boot = async () => {
  // Restaurar hash antes de que mainRouter() se ejecute
  let hashNeedRestore = false;
  if (!window.location.hash) {
    const savedHash = sessionStorage.getItem('__current_route_hash__');
    if (savedHash && savedHash !== '#/login') {
      window.location.hash = savedHash;
      hashNeedRestore = true;
    }
  }

  await setupAuthOnAppStart(); // ✅ Activa el timer de expiración

  // Si restauramos el hash, esperamos a que se procese
  if (hashNeedRestore) {
    await new Promise(resolve => setTimeout(resolve, 10));
  }

  mainRouter();
};

if (document.readyState === 'loading') {
  window.addEventListener('DOMContentLoaded', () => { void boot(); });
} else {
  void boot();
}

/* =========================================================================
   Eventos auxiliares
   ========================================================================= */

// Limpieza de "sticky" del router al hacer logout
window.addEventListener('app:logout', () => {
  try {
    sessionStorage.removeItem('__preserve_route__');
    sessionStorage.removeItem('__last_good_client_route__');
    sessionStorage.removeItem('__boot_sticky_applied__');
    sessionStorage.removeItem('__current_route_hash__');  // 🆕 Limpiar hash guardado
  } catch { }
});

// Reenrutado en cambios de hash (y guardar para restaurar en refresh)
window.addEventListener('hashchange', () => {
  // Guardar hash actual para restaurar en refresh
  const currentHash = window.location.hash;
  if (currentHash && !currentHash.includes('/login')) {
    try {
      sessionStorage.setItem('__current_route_hash__', currentHash);
    } catch { }
  }
  // ✅ NO llamar a mainRouter() aquí - ya se llama desde router.ts
});

// Sincroniza logout entre pestañas
// e.key llega con la clave ofuscada (btoa("ds_v1:auth_token"))
const _encodedAuthToken = btoa('ds_v1:auth_token');
window.addEventListener('storage', (e) => {
  if ((e.key === 'auth_token' || e.key === _encodedAuthToken) && !e.newValue) {
    if (!location.hash.startsWith('#/login')) {
      location.hash = '#/login';
    }
  }
});